// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inventory-page {
  flex: 1 1;
  background-color: #000000;
  color: #ffffff;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  margin: 0;
  box-sizing: border-box;
}

/* Header */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 40px;
  border-bottom: 1px solid #1f2937;
}

.header-title {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  color: #A61B34;
}

.header-title h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
}

.header-title p {
  margin: 4px 0 0 0;
  font-size: 14px;
  color: #9ca3af;
}

.header-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.btn-refresh {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #374151;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-refresh:hover:not(:disabled) {
  background: #4B5563;
  transform: translateY(-2px);
}

.btn-refresh:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-refresh .spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.btn-add {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #A61B34 0%, #8B1528 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-add:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(166, 27, 52, 0.4);
}

/* Filtros de inventario (cámaras) */
.inv-toolbar {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  padding: 16px 40px;
  margin-bottom: 8px;
  background: #0a0a0a;
  border-bottom: 1px solid #1f2937;
}

.inv-toolbar .inv-input {
  background: #111;
  border: 1px solid #2a2a2a;
  color: #fff;
  padding: 10px 12px;
  border-radius: 8px;
  outline: none;
  min-width: 240px;
  flex: 1 1;
}

.inv-toolbar .inv-select {
  background: #111;
  border: 1px solid #2a2a2a;
  color: #fff;
  padding: 10px 12px;
  border-radius: 8px;
  outline: none;
  min-width: 160px;
}

.inv-toolbar .inv-btn {
  background: #2a2a2a;
  color: #fff;
  border: 0;
  padding: 10px 14px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
}

.inv-toolbar .inv-btn:hover:not(:disabled) {
  background: #374151;
}

.inv-toolbar .inv-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Tabs */
.tabs-container {
  display: flex;
  gap: 0;
  padding: 0 40px;
  border-bottom: 2px solid #1f2937;
  background-color: #0a0a0a;
}

.tabs-container .tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 24px;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  color: #9ca3af;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  outline: none;
}

.tabs-container .tab:hover {
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.05);
}

.tabs-container .tab.active {
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.05);
}

.tabs-container .tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  background-color: #1f2937;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
}

.tabs-container .tab.active .tab-count {
  background-color: #A61B34;
}

/* Contenedor de dispositivos */
.devices-container {
  padding: 32px 40px 40px 40px;
}

/* Tabla de dispositivos */
.table-container {
  background: #1a1a1a;
  border: 1px solid #1f2937;
  border-radius: 12px;
  overflow: hidden;
}

.devices-table {
  width: 100%;
  border-collapse: collapse;
}

.devices-table thead {
  background: #0a0a0a;
  border-bottom: 2px solid #1f2937;
}

.devices-table th {
  padding: 16px 20px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.devices-table tbody tr {
  border-bottom: 1px solid #1f2937;
  transition: background-color 0.2s;
}

.devices-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.03);
}

.devices-table tbody tr:last-child {
  border-bottom: none;
}

.devices-table td {
  padding: 16px 20px;
  font-size: 14px;
  color: #e5e7eb;
  vertical-align: middle;
}

.description-cell {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.actions-cell {
  width: 120px;
  text-align: right;
}

.table-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.status-badge.active {
  background: rgba(34, 197, 94, 0.15);
  color: #22c55e;
}

.status-badge.inactive {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}

/* Estilos para columna de sitio (según diseño Figma) */
.text-green-500 {
  color: #22c55e;
}

.text-green-300 {
  color: #86efac;
}

.text-gray-500 {
  color: #6b7280;
}

.text-sm {
  font-size: 14px;
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.gap-2 {
  gap: 8px;
}

.btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #374151;
  border: none;
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-icon:hover {
  transform: scale(1.05);
}

.btn-edit:hover {
  background: #4B5563;
  color: #60A5FA;
}

.btn-delete:hover {
  background: #991B1B;
  color: #FCA5A5;
}

/* Estado vacío */
.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #6b7280;
}

.empty-state svg {
  margin: 0 auto 24px;
  opacity: 0.3;
}

.empty-state h3 {
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 600;
  color: #9ca3af;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
}

/* Loading */
.loading {
  text-align: center;
  padding: 80px 20px;
  font-size: 16px;
  color: #9ca3af;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: #1a1a1a;
  border: 1px solid #1f2937;
  border-radius: 16px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #1f2937;
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
}

.btn-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-close:hover {
  background: #374151;
  color: #ffffff;
}

.modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 24px;
  border-top: 1px solid #1f2937;
}

/* Formulario */
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #e5e7eb;
}

.form-group input[type="text"],
.form-group input[type="email"],
.form-group input[type="password"],
.form-group input[type="date"],
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px 12px;
  background: #0a0a0a;
  border: 1px solid #374151;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  transition: all 0.2s;
  font-family: inherit;
  resize: vertical;
}

.form-group input[type="text"]:focus,
.form-group input[type="email"]:focus,
.form-group input[type="password"]:focus,
.form-group input[type="date"]:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #A61B34;
  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);
}

.form-group input[type="checkbox"] {
  margin-right: 8px;
  width: 18px;
  height: 18px;
  cursor: pointer;
}

/* Botones */
.btn-primary,
.btn-secondary {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary {
  background: linear-gradient(135deg, #A61B34 0%, #8B1528 100%);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(166, 27, 52, 0.4);
}

.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-secondary {
  background: #374151;
  color: #e5e7eb;
}

.btn-secondary:hover {
  background: #4B5563;
}

/* Sección de Catálogos */
.catalog-section {
  padding: 24px 40px 40px;
}

.catalog-selectors {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 20px;
  margin-bottom: 24px;
  padding: 20px;
  background: #1a1a1a;
  border: 1px solid #1f2937;
  border-radius: 12px;
}

.catalog-selectors .form-group {
  margin: 0;
  min-width: 180px;
}

.catalog-selectors .form-group label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.catalog-select {
  min-width: 160px;
}

.catalog-add-btn {
  margin-left: auto;
}

/* Responsive */
@media (max-width: 768px) {
  .page-header {
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .header-actions {
    width: 100%;
    flex-direction: column;
  }

  .btn-refresh,
  .btn-add {
    width: 100%;
    justify-content: center;
  }

  .tabs-container {
    padding: 0 20px;
    overflow-x: auto;
  }

  .tab {
    white-space: nowrap;
  }

  .devices-container {
    padding: 20px;
  }

  .table-container {
    overflow-x: auto;
  }

  .devices-table {
    min-width: 600px;
  }

  .devices-table th,
  .devices-table td {
    padding: 12px 16px;
    font-size: 13px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/InventoryPage.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,MAAM;EACN,eAAe;EACf,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;EAME,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;;;;;EAME,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,YAAY;AACZ;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".inventory-page {\n  flex: 1;\n  background-color: #000000;\n  color: #ffffff;\n  height: 100%;\n  width: 100%;\n  overflow-y: auto;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n/* Header */\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 32px 40px;\n  border-bottom: 1px solid #1f2937;\n}\n\n.header-title {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.header-icon {\n  color: #A61B34;\n}\n\n.header-title h1 {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.header-title p {\n  margin: 4px 0 0 0;\n  font-size: 14px;\n  color: #9ca3af;\n}\n\n.header-actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.btn-refresh {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #374151;\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-refresh:hover:not(:disabled) {\n  background: #4B5563;\n  transform: translateY(-2px);\n}\n\n.btn-refresh:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-refresh .spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.btn-add {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: linear-gradient(135deg, #A61B34 0%, #8B1528 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-add:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(166, 27, 52, 0.4);\n}\n\n/* Filtros de inventario (cámaras) */\n.inv-toolbar {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-wrap: wrap;\n  padding: 16px 40px;\n  margin-bottom: 8px;\n  background: #0a0a0a;\n  border-bottom: 1px solid #1f2937;\n}\n\n.inv-toolbar .inv-input {\n  background: #111;\n  border: 1px solid #2a2a2a;\n  color: #fff;\n  padding: 10px 12px;\n  border-radius: 8px;\n  outline: none;\n  min-width: 240px;\n  flex: 1;\n}\n\n.inv-toolbar .inv-select {\n  background: #111;\n  border: 1px solid #2a2a2a;\n  color: #fff;\n  padding: 10px 12px;\n  border-radius: 8px;\n  outline: none;\n  min-width: 160px;\n}\n\n.inv-toolbar .inv-btn {\n  background: #2a2a2a;\n  color: #fff;\n  border: 0;\n  padding: 10px 14px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.inv-toolbar .inv-btn:hover:not(:disabled) {\n  background: #374151;\n}\n\n.inv-toolbar .inv-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Tabs */\n.tabs-container {\n  display: flex;\n  gap: 0;\n  padding: 0 40px;\n  border-bottom: 2px solid #1f2937;\n  background-color: #0a0a0a;\n}\n\n.tabs-container .tab {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 16px 24px;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  color: #9ca3af;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  position: relative;\n  outline: none;\n}\n\n.tabs-container .tab:hover {\n  color: #ffffff;\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.tabs-container .tab.active {\n  color: #ffffff;\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.tabs-container .tab-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 24px;\n  height: 24px;\n  padding: 0 8px;\n  background-color: #1f2937;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.tabs-container .tab.active .tab-count {\n  background-color: #A61B34;\n}\n\n/* Contenedor de dispositivos */\n.devices-container {\n  padding: 32px 40px 40px 40px;\n}\n\n/* Tabla de dispositivos */\n.table-container {\n  background: #1a1a1a;\n  border: 1px solid #1f2937;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.devices-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.devices-table thead {\n  background: #0a0a0a;\n  border-bottom: 2px solid #1f2937;\n}\n\n.devices-table th {\n  padding: 16px 20px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.devices-table tbody tr {\n  border-bottom: 1px solid #1f2937;\n  transition: background-color 0.2s;\n}\n\n.devices-table tbody tr:hover {\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.devices-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.devices-table td {\n  padding: 16px 20px;\n  font-size: 14px;\n  color: #e5e7eb;\n  vertical-align: middle;\n}\n\n.description-cell {\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.actions-cell {\n  width: 120px;\n  text-align: right;\n}\n\n.table-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.status-badge.active {\n  background: rgba(34, 197, 94, 0.15);\n  color: #22c55e;\n}\n\n.status-badge.inactive {\n  background: rgba(239, 68, 68, 0.15);\n  color: #ef4444;\n}\n\n/* Estilos para columna de sitio (según diseño Figma) */\n.text-green-500 {\n  color: #22c55e;\n}\n\n.text-green-300 {\n  color: #86efac;\n}\n\n.text-gray-500 {\n  color: #6b7280;\n}\n\n.text-sm {\n  font-size: 14px;\n}\n\n.flex {\n  display: flex;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.gap-2 {\n  gap: 8px;\n}\n\n.btn-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background: #374151;\n  border: none;\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-icon:hover {\n  transform: scale(1.05);\n}\n\n.btn-edit:hover {\n  background: #4B5563;\n  color: #60A5FA;\n}\n\n.btn-delete:hover {\n  background: #991B1B;\n  color: #FCA5A5;\n}\n\n/* Estado vacío */\n.empty-state {\n  text-align: center;\n  padding: 80px 20px;\n  color: #6b7280;\n}\n\n.empty-state svg {\n  margin: 0 auto 24px;\n  opacity: 0.3;\n}\n\n.empty-state h3 {\n  margin: 0 0 8px 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #9ca3af;\n}\n\n.empty-state p {\n  margin: 0;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n/* Loading */\n.loading {\n  text-align: center;\n  padding: 80px 20px;\n  font-size: 16px;\n  color: #9ca3af;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-content {\n  background: #1a1a1a;\n  border: 1px solid #1f2937;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px;\n  border-bottom: 1px solid #1f2937;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.btn-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-close:hover {\n  background: #374151;\n  color: #ffffff;\n}\n\n.modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 24px;\n  border-top: 1px solid #1f2937;\n}\n\n/* Formulario */\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #e5e7eb;\n}\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"email\"],\n.form-group input[type=\"password\"],\n.form-group input[type=\"date\"],\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px 12px;\n  background: #0a0a0a;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 14px;\n  transition: all 0.2s;\n  font-family: inherit;\n  resize: vertical;\n}\n\n.form-group input[type=\"text\"]:focus,\n.form-group input[type=\"email\"]:focus,\n.form-group input[type=\"password\"]:focus,\n.form-group input[type=\"date\"]:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #A61B34;\n  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);\n}\n\n.form-group input[type=\"checkbox\"] {\n  margin-right: 8px;\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n/* Botones */\n.btn-primary,\n.btn-secondary {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #A61B34 0%, #8B1528 100%);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(166, 27, 52, 0.4);\n}\n\n.btn-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  background: #374151;\n  color: #e5e7eb;\n}\n\n.btn-secondary:hover {\n  background: #4B5563;\n}\n\n/* Sección de Catálogos */\n.catalog-section {\n  padding: 24px 40px 40px;\n}\n\n.catalog-selectors {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 20px;\n  margin-bottom: 24px;\n  padding: 20px;\n  background: #1a1a1a;\n  border: 1px solid #1f2937;\n  border-radius: 12px;\n}\n\n.catalog-selectors .form-group {\n  margin: 0;\n  min-width: 180px;\n}\n\n.catalog-selectors .form-group label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.catalog-select {\n  min-width: 160px;\n}\n\n.catalog-add-btn {\n  margin-left: auto;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .page-header {\n    padding: 20px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .header-actions {\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .btn-refresh,\n  .btn-add {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .tabs-container {\n    padding: 0 20px;\n    overflow-x: auto;\n  }\n\n  .tab {\n    white-space: nowrap;\n  }\n\n  .devices-container {\n    padding: 20px;\n  }\n\n  .table-container {\n    overflow-x: auto;\n  }\n\n  .devices-table {\n    min-width: 600px;\n  }\n\n  .devices-table th,\n  .devices-table td {\n    padding: 12px 16px;\n    font-size: 13px;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
